export default __webpack_public_path__ + "static/media/1.15da8217.png";